import * as React from 'react';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { IRolesSectionProps } from './types';
import { BOARD_SECTION_ROLES_TITLE } from '../../constants';
import { BoardRoles } from '../BoardRoles/BoardRoles';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`RolesSection`) : null;

export function RolesSection ({
    isEssentialFeature,
    sectionType,
    onClickDisallow
}: IRolesSectionProps) {
    if (analyzeRender) analyzeRender.call(`RolesSection`);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--roles';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.ROLES} />
            <SettingsSection
                className={className}
                sectionType={sectionType}
                title={BOARD_SECTION_ROLES_TITLE}
                isEssentialFeature={isEssentialFeature}
                onClickDisallow={onClickDisallow}
            >
                <BoardRoles />
            </SettingsSection>
        </>
    );
};
